import {
    RESET_MENU_ITEM_DETAILS,
    RESET_ALL_MENU_ITEMS,
    SAVE_MENU_ITEM_DETAILS,
    SAVE_ALL_MENU_ITEMS,
} from "../types";

const INITIAL_STATE = {
    menuItems: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 500,
    },
    menuItemDetails: {},
};

const menuItemReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case SAVE_ALL_MENU_ITEMS:
            return {
                ...state,
                menuItems: {
                    pageSize: 10, // or state.menuItems.pageSize if preferred
                    ...payload,
                },
            };

        case RESET_ALL_MENU_ITEMS:
            return {
                ...state,
                menuItems: INITIAL_STATE.menuItems,
            };

        case SAVE_MENU_ITEM_DETAILS:
            return {
                ...state,
                menuItemDetails: {
                    ...payload,
                },
            };

        case RESET_MENU_ITEM_DETAILS:
            return {
                ...state,
                menuItemDetails: INITIAL_STATE.menuItemDetails,
            };

        default:
            return state;
    }
};

export default menuItemReducer;
